export default __webpack_public_path__ + "static/media/Tesla-1.3ab898be.svg";